module.exports = __webpack_public_path__ + "img/XCP-alt.54df290b.svg";